import { Component, OnInit } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router';
import { User } from './models/user';
@Component({
  selector: 'app-home',
  template: `
    <p>
      Welcome
    </p>
  `,
  styles: [],
})
export class HomeComponent implements OnInit {
	user:User;
	constructor(public router: Router) { 
  	}
	ngOnInit(): void {
		this.user = JSON.parse(localStorage.getItem('user_profile'));
		if(!!this.user && this.user.role != undefined){
			if(this.user.role.name == 'admin'){
				this.router.navigateByUrl('/admin');
			}else{
				this.router.navigateByUrl('/member');
			}
		}
	}
}